
import Vue from "vue";

export default Vue.extend({
  name: "Paginator",
  props: {
    value: {
      type: Number,
      required: true,
    },
    totalRows: {
      type: Number,
      required: true,
    },
    perPage: {
      type: Number,
      required: true,
    }
  },
  computed: {
    myModel: {
      set(value: number) {
        this.$emit("input", value)
      },
      get(): number {
        return this.value;
      }
    }
  }
});

